import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullseye, faFireFlameCurved, faTrophy } from "@fortawesome/free-solid-svg-icons";

const StatusCard = ({ projetoFocoId }) => {
  return (
    <Row className="mt-3 g-3">

      <Col md={4}>
        <Card className="mini-card">
          <Card.Body>
            <small className="text-muted">
              <FontAwesomeIcon icon={faFireFlameCurved} className="me-1 text-warning" />
              Sequência
            </small>
            <h5 className="mt-2 mb-0">0 dias</h5>
          </Card.Body>
        </Card>
      </Col>

      <Col md={4}>
        <Card className="mini-card">
          <Card.Body>
            <small className="text-muted">
              <FontAwesomeIcon icon={faBullseye} className="me-1 text-primary" />
              Planejamento
            </small>
            <h6 className="mt-2 mb-0">Planeje seu dia</h6>
          </Card.Body>
        </Card>
      </Col>

      <Col md={4}>
        <Card className="mini-card">
          <Card.Body>
            <small className="text-muted">
              <FontAwesomeIcon icon={faTrophy} className="me-1 text-warning" />
              Projeto em foco
            </small>
            <h6>{projetoFocoId ? 'Em execução' : 'Nenhum definido'}</h6>
          </Card.Body>
        </Card>
      </Col>

    </Row>
  );
};

export default StatusCard;
